import React from 'react';

import Link from 'next/link';

const teamMembers = [
  { id: 'tm-001', name: 'Sophia Reyes', rank: 'Gold', pv: 1240, status: 'Active', initials: 'SR' },
  { id: 'tm-002', name: 'Daniel Cruz', rank: 'Silver', pv: 890, status: 'Active', initials: 'DC' },
  { id: 'tm-003', name: 'Andrea Garcia', rank: 'Member', pv: 340, status: 'Active', initials: 'AG' },
  { id: 'tm-004', name: 'Carlos Mendez', rank: 'Member', pv: 120, status: 'Inactive', initials: 'CM' },
  { id: 'tm-005', name: 'Yuki Tanaka', rank: 'Member', pv: 560, status: 'Active', initials: 'YT' },
];

const rankColors: Record<string, string> = {
  Gold: 'text-primary',
  Silver: 'text-slate-500',
  Member: 'text-muted-foreground',
};

export default function TeamSnapshot() {
  return (
    <div className="card-elevated rounded-xl overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">My Team</h3>
        <Link href="/my-team" className="text-xs text-primary font-medium hover:text-primary-dark">
          View All →
        </Link>
      </div>
      <div className="divide-y divide-border">
        {teamMembers.map(member => (
          <div key={member.id} className="flex items-center gap-3 px-4 py-3 hover:bg-muted/40 transition-colors">
            <div className="w-8 h-8 rounded-full bg-gradient-gold flex items-center justify-center flex-shrink-0">
              <span className="text-[10px] font-bold text-white">{member.initials}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-foreground truncate">{member.name}</p>
              <p className={`text-[10px] font-medium ${rankColors[member.rank]}`}>{member.rank}</p>
            </div>
            <div className="text-right">
              <p className="text-xs font-bold text-foreground tabular-nums">{member.pv}</p>
              <p className="text-[10px] text-muted-foreground">PV</p>
            </div>
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${member.status === 'Active' ? 'bg-success' : 'bg-muted-foreground/30'}`} />
          </div>
        ))}
      </div>
      <div className="p-4 border-t border-border bg-muted/20">
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">18 total team members</span>
          <span className="font-semibold text-primary">18,340 TV</span>
        </div>
      </div>
    </div>
  );
}